import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { formatDistanceToNow } from 'date-fns';

const DataFreshnessIndicator = ({ lastRefreshTime, onRefresh, isRefreshing }) => {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    if (lastRefreshTime) {
      updateTimeAgo();
      
      // Update time ago every 10 seconds
      const interval = setInterval(() => {
        updateTimeAgo();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [lastRefreshTime]);

  const updateTimeAgo = () => {
    if (lastRefreshTime) {
      try {
        const distance = formatDistanceToNow(new Date(lastRefreshTime), { addSuffix: true });
        setTimeAgo(distance);
      } catch (err) {
        setTimeAgo('recently');
      }
    }
  };

  const getFreshnessColor = () => {
    if (!lastRefreshTime) return 'text-gray-500';
    
    const minutesAgo = (Date.now() - new Date(lastRefreshTime)?.getTime()) / 1000 / 60;
    
    if (minutesAgo < 2) return 'text-green-600';
    if (minutesAgo < 5) return 'text-yellow-600';
    return 'text-orange-600';
  };

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        <Icon
          name="Clock"
          className={`w-4 h-4 ${getFreshnessColor()}`}
        />
        <div className="flex flex-col">
          <span className="text-xs text-gray-500">Last sync</span>
          <span className={`text-sm font-medium ${getFreshnessColor()}`}>
            {lastRefreshTime ? timeAgo : 'Not synced'}
          </span>
        </div>
      </div>
      
      <button
        onClick={onRefresh}
        disabled={isRefreshing}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title="Refresh dashboard data"
      >
        <Icon
          name="RefreshCw"
          className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`}
        />
        <span>{isRefreshing ? 'Syncing...' : 'Refresh'}</span>
      </button>
    </div>
  );
};

export default DataFreshnessIndicator;